import Component from '@glimmer/component';
import urlBuilder from 'garaje/utils/url-builder';

export default class RoombaCalendarConnectComponent extends Component {
  googleAuthUrl = urlBuilder.roomba.googleAuthUrl();
  microsoftAuthUrl = urlBuilder.roomba.microsoftAuthUrl();
  microsoftOfficeUrl = urlBuilder.roomba.microsoftOfficeUrl();
}
